import React, { useEffect, JSX } from 'react';
import { Row } from 'reactstrap';
import { forceCheck } from 'react-lazyload';
import FadeIn from './FadeIn';
import Keys from '../Translations/generated/search-content.de.json.keys';
import fallback from '../Translations/generated/search-content.de.json';
import { useTranslation } from '@ibe/components';
import ResultListItem from './ResultListItem';
import LazyLoadElement from './LazyLoadElement';
import { ApiProductCard } from '../../api';

const ResultList = ({
  productResultItems
}: {
  productResultItems: ApiProductCard[];
}): JSX.Element => {
  const { t } = useTranslation('search-content', fallback);

  useEffect(() => {
    setTimeout(() => {
      forceCheck();
    }, 300);
  }, productResultItems);

  const handleItemClick = (item: ApiProductCard): void => {
    location.href = item.detailUrl;
  };

  return (
    <div>
      <div className="result-list__number">{`${productResultItems.length} ${t(Keys.travel, {
        count: productResultItems.length
      })}`}</div>
      <Row>
        {productResultItems.map(item => (
          <LazyLoadElement
            className="result-list__lazy-element"
            key={`${item.name}-${item.dateInfo}`}
            scroll={true}
            resize={true}
          >
            <FadeIn>
              <ResultListItem
                productResultItem={item}
                className="mb-5"
                onClick={() => handleItemClick(item)}
              />
            </FadeIn>
          </LazyLoadElement>
        ))}
      </Row>
    </div>
  );
};

export default ResultList;
